/*global mdui */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { DataStore } from '@store/';
import {
    DATA_TYPE_STREET,
    DATA_TYPE_PARKING,
    DATA_TYPE_OIL,
    DATA_TYPE_NEWENERGY,
    DATA_TYPE_WC,
} from "@utils/dataType";
import "./index.scoped.sass";

@inject(stores => ({
    dataStore: stores.dataStore,
}))
@observer
class FloatBtn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btn: '',
        };
    }

    componentDidMount() {
        this.setState({
            btn: new mdui.Fab('#floatBtn', { trigger: '' }),
        });
    }
    toggle = () => {
        this.state.btn.toggle();
    }
    close = () => {
        this.state.btn.close();
    }
    changeType = (type) => {
        this.props.dataStore.changeType(type);
        this.close();
    }
    render() {
        // 这里必须给默认值 让第一次 Dom 全部渲染出来，不然 mdui js 就没有初始化了
        const dataType = this.props.dataStore.dataType ? this.props.dataStore.dataType : DATA_TYPE_STREET;
        const typeIconMap = {
            [DATA_TYPE_NEWENERGY]: { name: 'power', hnName: "新能源", color: 'mdui-color-green-600' },
            [DATA_TYPE_OIL]: { name: 'local_gas_station', hnName: "加油站", color: 'mdui-color-yellow' },
            [DATA_TYPE_PARKING]: { name: 'local_parking', hnName: "停车场", color: 'mdui-color-blue-600' },
            [DATA_TYPE_STREET]: { name: 'nature_people', hnName: "路边停车", color: 'mdui-color-red' },
            [DATA_TYPE_WC]: { name: 'wc', hnName: "建宁驿站", color: 'mdui-color-deep-purple' },
        };

        return (
            <div className="mdui-fab-wrapper" id="floatBtn" >
                <button className={`mdui-fab mdui-fab-mini mdui-ripple ${typeIconMap[dataType].color} ${dataType}`} onClick={this.toggle}>
                    <i className="mdui-icon material-icons">{typeIconMap[dataType].name}</i>
                    <i className="mdui-icon mdui-fab-opened material-icons">close</i>
                </button>
                <div className="mdui-fab-dial">
                    <button
                        className="mdui-fab mdui-fab-mini mdui-ripple mdui-color-green-600 newEnergy"
                        mdui-tooltip="{position:'left',content:'新能源'}"
                        onClick={() => { this.changeType(DATA_TYPE_NEWENERGY); }}
                    >
                        <i className="mdui-icon material-icons">power</i>
                    </button>
                    <button
                        className="mdui-fab mdui-fab-mini mdui-ripple mdui-color-yellow oil"
                        mdui-tooltip="{position:'left',content:'加油站'}"
                        onClick={() => { this.changeType(DATA_TYPE_OIL); }}
                    >
                        <i className="mdui-icon material-icons">local_gas_station</i>
                    </button>
                    <button
                        className="mdui-fab mdui-fab-mini mdui-ripple mdui-color-blue-600 parking"
                        mdui-tooltip="{position:'left',content:'停车场'}"
                        onClick={() => { this.changeType(DATA_TYPE_PARKING); }}
                    >
                        <i className="mdui-icon material-icons">local_parking</i>
                    </button>
                    <button
                        className="mdui-fab mdui-fab-mini mdui-ripple mdui-color-red street"
                        mdui-tooltip="{position:'left',content:'路边停车'}"
                        onClick={() => { this.changeType(DATA_TYPE_STREET); }}
                    >
                        <i className="mdui-icon material-icons">nature_people</i>
                    </button>
                    {/* <button
                        className="mdui-fab mdui-fab-mini mdui-ripple mdui-color-deep-purple wc"
                        mdui-tooltip="{position:'left',content:'建宁驿站'}"
                        onClick={() => { this.changeType(DATA_TYPE_WC); }}
                    >
                        <i className="mdui-icon material-icons">wc</i>
                    </button> */}
                </div>
            </div >
        );
    }
}

FloatBtn.wrappedComponent.propTypes = {
    dataStore: PropTypes.instanceOf(DataStore).isRequired,
};

export default FloatBtn;